import React, { useRef, useState } from "react";
import styled, { keyframes } from "styled-components";
import music from "../assets/audio/music.mp3";

import { IoMusicalNotes } from "react-icons/io5";

const Box = styled.div`
  display: flex;
  cursor: pointer;
  position: fixed;
  left: 11vw;
  top: 2.5rem;
  z-index: 5;

  & > *:nth-child(1) {
    animation-delay: 0.2s;
  }

  & > *:nth-child(2) {
    animation-delay: 0.3s;
  }

  & > *:nth-child(3) {
    animation-delay: 0.4s;
  }

  & > *:nth-child(4) {
    animation-delay: 0.6s;
  }

  & > *:nth-child(5) {
    animation-delay: 0.8s;
  }

  .musicLogo {
    position: absolute;
    left: -2.2rem;
    top: -1.3rem;
    color: ${(props) => `rgba(${props.theme.textRgba}, 0.1)`};
    font-size: calc(1.9rem + 2vw);
  }

  @media (max-width: 1060px) {
    left: 15vw;
  }

  @media (max-width: 819px) {
    left: 18vw;
  }

  @media (max-width: 595px) {
    left: 11vw;
    top: 5rem;

    .musicLogo {
      left: -1.7rem;
      top: -0.5rem;
    }
  }
`;

const play = keyframes`
0%{
  transform:scaleY(1);
}
50%{
  transform:scaleY(2);
}
100%{
  transform:scaleY(1);
}
`;

const Line = styled.span`
  background: ${(props) => props.theme.text};
  border: 1px solid ${(props) => props.theme.body};
  animation: ${play} 1s ease infinite;
  animation-play-state: ${(props) => (props.click ? "running" : "paused")};
  height: 1.5rem;
  width: 2px;
  margin: 0 0.2rem;
`;

const SoundBar = () => {
  const ref = useRef(null);
  const [click, setClick] = useState(false);

  const handleClick = () => {
    setClick(!click);

    if (!click) {
      ref.current.play();
    } else {
      ref.current.pause();
    }
  };

  return (
    <Box onClick={() => handleClick()}>
      <IoMusicalNotes className="musicLogo" />
      <Line click={click} />
      <Line click={click} />
      <Line click={click} />
      <Line click={click} />
      <Line click={click} />

      <audio src={music} ref={ref} loop />
    </Box>
  );
};

export default SoundBar;
